import { PROCESS_STEPS } from '@/data/homeContent';

export const ProcessSteps = () => (
  <section id="folyamat" aria-labelledby="folyamat-cim" className="scroll-mt-24 pb-16 sm:pb-20">
    <div className="mx-auto w-full max-w-[1220px] px-4 sm:px-6">
      <div className="mb-10 max-w-[56ch]">
        <h2 id="folyamat-cim" className="text-2xl">
          Négy lépés, és az ágy otthon van
        </h2>
        <p className="mt-3 text-ink-soft">
          Nem kell regisztrálni, és nem kell hosszú űrlapot kitölteni. Ha egyszerűbb telefonon, hívjon
          minket – ugyanígy felvesszük a rendelést.
        </p>
      </div>

      <ol className="grid list-none gap-4 p-0 sm:grid-cols-2 lg:grid-cols-4">
        {PROCESS_STEPS.map((step, index) => (
          <li key={step.title} className="rounded-xl bg-paper p-7">
            <span
              className="grid size-11 place-items-center rounded-full bg-sand font-display text-lg font-bold text-navy"
              aria-hidden="true"
            >
              {index + 1}
            </span>
            <p className="mt-4 font-display text-lg font-bold text-navy">
              <span className="sr-only">{index + 1}. lépés: </span>
              {step.title}
            </p>
            <p className="mt-1.5 text-sm text-ink-soft">{step.description}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
